import { injectGlobal } from 'styled-components';

const NavStyles = injectGlobal`
/*--------------------------------------------------------------
# Navigation Menu
--------------------------------------------------------------*/


/* Nav Menu Essentials */

.nav-menu,
.nav-menu * {
	margin: 0;
	padding: 0;
	list-style: none;
}

.nav-menu ul {
	position: absolute;
	display: none;
	top: 100%;
	left: 0;
	z-index: 99;
	top: 60px;
}

.nav-menu li {
	position: relative;
	white-space: nowrap;
}

.nav-menu>li {
	float: left;
}

.nav-menu li:hover>ul,
.nav-menu li.sfHover>ul {
	display: block;
}

.nav-menu ul ul {
	top: 0;
	left: 100%;
}

.nav-menu ul li {
	min-width: 180px;
}


/* Nav Menu Arrows */

.sf-arrows .sf-with-ul {
	padding-right: 22px;
	cursor: pointer;
}

.sf-arrows .sf-with-ul:after {
	/* content: "\f107"; */
	font-family: FontAwesome;
	content: "\f0dd";
	position: absolute;
	right: 8px;
	margin-top: -2px;
	font-style: normal;
}

.sf-arrows ul .sf-with-ul:after {
	content: "\f105";
}


/* Nav Meu Container */

#nav-menu-container {
	float: right;
	margin: 0 0 0 0;
}

@media (max-width: 1024px) {
	#nav-menu-container {
		display: none;
	}
}


/* Nav Meu Styling */

.nav-menu a {
	padding: 8px 8px;
	text-decoration: none;
	display: inline-block;
	color: #505050;
	outline: none;
	transition: 0.3s;
}

.nav-menu a.button {
	background: ${(props) => props.theme.primaryColor};
	border-radius: 25px;
	border: ${(props) => props.theme.whiteColor} solid 1px;
	padding: 4px 20px;
	color: ${(props) => props.theme.whiteColor};
	margin-top: 3px;
}

.nav-menu a.button:hover {
	background: #f95a61;
	color: ${(props) => props.theme.whiteColor};
}

.save-landing #mobile-nav-toggle{
	margin: -11px 20px 0 0 !important;
}

.save-container{
	max-width: 100% !important;
	padding: 0px 50px;
}

.nav-menu a.white-button {
	display: inline-block;
    font-weight: 400;
    text-align: center;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid ${(props) => props.theme.transparentColor};
    white-space: nowrap;
    padding: 0 15px;
    font-size: 14px;
    border-radius: 4px;
    height: 32px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    position: relative;
    -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
	box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
    color: rgba(0, 0, 0, 0.65);
    background-color: ${(props) => props.theme.whiteColor};
    border-color: ${(props) => props.theme.lightGray};
	margin-top: 8px;
}

.nav-menu a.white-button:hover {
	color: rgb(229, 35, 47);
    border-color: rgb(229, 35, 47);
}

.nav-menu a.green-button {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid ${(props) => props.theme.transparentColor};
    white-space: nowrap;
    padding: 0 15px;
    font-size: 14px;
    border-radius: 4px;
    height: 32px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    position: relative;
    -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
	box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
	background-color: rgb(52, 170, 68);
	border-color: rgb(36, 149, 51);
	color:${(props) => props.theme.whiteColor};
	margin-top: 8px;
}

.nav-menu a.green-button:hover {
	background-color: rgb(30, 147, 11);
	border-color: rgb(31, 135, 45);
	color: ${(props) => props.theme.whiteColor};
}


a.green-button {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid ${(props) => props.theme.transparentColor};
    white-space: nowrap;
    padding: 5px 15px;
    font-size: 14px;
    border-radius: 4px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    position: relative;
    -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
	box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
	background-color: rgb(52, 170, 68);
	border-color: rgb(36, 149, 51);
	color:${(props) => props.theme.whiteColor};
	margin-top: 8px;
}

a.green-button:hover {
	background-color: rgb(30, 147, 11);
	border-color: rgb(31, 135, 45);
	color:${(props) => props.theme.whiteColor};
	text-decoration: none;
}

.nav-menu li:hover>a,
.nav-menu>.menu-active>a {
	color: ${(props) => props.theme.primaryColor}
}

.nav-menu>li {
	margin-left: 30px;
}

.nav-menu ul {
	margin: 0;
	padding: 10px;
	box-shadow: 0px 0px 30px rgba(127, 137, 161, 0.25);
	background: ${(props) => props.theme.whiteColor};
}

.nav-menu ul li {
	transition: 0.3s;
}

.nav-menu ul li a {
	padding: 5px 10px;
	color: ${(props) => props.theme.secondaryColor};
	transition: 0.3s;
	display: block;
}

.nav-menu ul li:hover>a {
	color: ${(props) => props.theme.primaryColor}
}

.nav-menu ul ul {
	margin: 0;
}


/* Mobile Nav Toggle */

#mobile-nav-toggle {
	position: fixed;
	right: 0;
	top: 35px;
	z-index: 999;
	margin: 4px 20px 0 0;
	border: 0;
	background: none;
	display: none;
	transition: all 0.4s;
	outline: none;
	cursor: pointer;
}

#mobile-nav-toggle i {
	color: #555;
}


/* Mobile Nav Styling */

#mobile-nav {
	position: fixed;
	top: 0;
	padding-top: 18px;
	bottom: 0;
	z-index: 998;
	background: rgba(52, 59, 64, 0.9);
	left: -260px;
	width: 260px;
	overflow-y: auto;
	transition: 0.4s;
}

#mobile-nav ul {
	padding: 0;
	margin: 0;
	list-style: none;
}

#mobile-nav ul li {
	position: relative;
}

#mobile-nav ul li a {
	color: ${(props) => props.theme.whiteColor};
	overflow: hidden;
	padding: 6px 22px 6px 15px;
	position: relative;
	text-decoration: none;
	width: 100%;
	display: block;
	outline: none;
}

#mobile-nav ul li a:hover {
	color: ${(props) => props.theme.whiteColor};
}

#mobile-nav ul li li {
	padding-left: 30px;
}

#mobile-nav ul .menu-has-children i {
	position: absolute;
	right: 0;
	z-index: 99;
	padding: 15px;
	cursor: pointer;
	color:${(props) => props.theme.whiteColor};
}

#mobile-nav ul .menu-has-children i.fa-chevron-up {
	color: ${(props) => props.theme.primaryColor};
}

#mobile-nav ul .menu-item-active {
	color: ${(props) => props.theme.primaryColor};
}

#mobile-body-overly {
	width: 100%;
	height: 100%;
	z-index: 997;
	top: 0;
	left: 0;
	position: fixed;
	background: rgba(52, 59, 64, 0.9);
	display: none;
}


/* Mobile Nav body classes */

body.mobile-nav-active {
	overflow: hidden;
}

body.mobile-nav-active #mobile-nav {
	left: 0;
}

body.mobile-nav-active #mobile-nav-toggle i {
	color:${(props) => props.theme.whiteColor};
}

`;

export default NavStyles;



// WEBPACK FOOTER //
// client/components/StyledLanding/cssNav.js